// JWT token utilities for the frontend

export const getUserFromToken = (token) => {
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return {
      id: payload.nameid || payload.sub,
      email: payload.email,
      name: payload.unique_name || payload.name
    };
  } catch (error) {
    return null;
  }
};
